import { createContext, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MasterDataContext } from "../MasterDataContext";
import logAnalytics from "./analytics";
import PropTypes from "prop-types";

export const FireBaseContext = createContext();

function FireBaseContextProvider(props) {
  const {
    state: { schoolDetails, userDetails },
  } = useContext(MasterDataContext);
  const [isAppMounted, setAppMounted] = useState(false);

  useEffect(() => {
    setAppMounted(true);
  }, []);
  const { i18n } = useTranslation();

  const logEvent = (eventName, additionalData = {}) => {
    let schoolId;
    let userId;
    if (Object.keys(schoolDetails).length) {
      schoolId = schoolDetails.schoolId;
      userId = userDetails.userId;
    }
    let loggingData = {
      Language: i18n.dir() === "rtl" ? "AR" : "EN",
      ...additionalData,
      ...(schoolId ? { SchoolID: schoolId } : null),
      ...(userId ? { UserID: userId } : null),
    };
    logAnalytics(eventName, loggingData);
  };

  return (
    <FireBaseContext.Provider value={{ logEvent, isAppMounted }}>
      {props.children}
    </FireBaseContext.Provider>
  );
}

FireBaseContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export default FireBaseContextProvider;
